import { gql } from '@apollo/client';

export const ORDER_CREATE = gql`
  mutation OrderCreate($input: OrderInput!) {
    orderCreate(input: $input) {
      id
      type
      date
      title
      createdById
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;

export const PROPOSAL_ORDER_CREATE = gql`
  mutation ProposalOrderCreate($projectId: ID!) {
    proposalOrderCreate(projectId: $projectId) {
      id
      type
      date
      title
      createdById
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;

export const SITE_PLAN_ORDER_CREATE = gql`
  mutation SitePlanOrderCreate($projectId: ID!) {
    sitePlanOrderCreate(projectId: $projectId) {
      id
      type
      date
      title
      createdById
      createdBy {
        id
        name
        email
      }
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;

export const ORDER_UPDATE = gql`
  mutation OrderUpdate($id: ID!, $input: OrderUpdateInput!) {
    orderUpdate(id: $id, input: $input) {
      id
      type
      date
      title
      createdById
      createdBy {
        id
        name
        email
      }
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;
